// extracted by mini-css-extract-plugin
export var button = "_6l-4";
export var hasDarkBackground = "_6l-7";
export var hasLightBackground = "_6l-6";
export var iconWrapper = "_6l-0";
export var large = "_6l-2";
export var medium = "_6l-1";
export var small = "_6l-5";
export var xsmall = "_6l-3";